import { Component } from '@angular/core'
import { SplashScreen } from '@ionic-native/splash-screen'
import { StatusBar } from '@ionic-native/status-bar'
import { Platform, ToastController } from 'ionic-angular'
import { Observable } from 'rxjs/Observable'

import { Meeting, User } from '../models/models'
import { UserAuthProvider } from '../modules/mrk-user-auth/user-auth'
import { UserState } from '../modules/mrk-user-auth/user-auth-models'
import { LoginPage } from '../pages/login/login'
import { MainPage } from '../pages/main/main'
import { MeetingsToDoListPage } from '../pages/meetings-to-do-list/meetings-to-do-list'
import { ApiProvider } from '../providers/api/api'
import { SettingsProvider } from '../providers/settings/settings'


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any;
  lastState: UserState<User>;

  MEETING_PLANNED = 1
  planned_page = 0

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private toastCtrl: ToastController, userAuth: UserAuthProvider<User>, private api: ApiProvider, public settings: SettingsProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
    userAuth.setPermission(user => Observable.of(user.is_staff))
    userAuth.userState
      .concatMap(state => {
        this.lastState = state
        if (state.logged) {
          return this.api.getOperator(state.user.id)
            .map(operator => {
              this.lastState.user.operator = operator
              return this.lastState
            })
        } else {
          return Observable.of(state)
        }
      })
      .subscribe(state => {
        if (state.logged) {
          if (state.has_permission) {
            this.planned_page++
            this.api.getPaginatedMeetings(state.user.operator.id, [this.MEETING_PLANNED], null, null, false, this.planned_page).subscribe(
              page => {
                let meetings_planned: Meeting[] = []
                meetings_planned.push(...page.results)
                meetings_planned = meetings_planned.filter(meeting_planned => {
                  return new Date(meeting_planned.schedule_datetime) < new Date()
                })
                const noToDo = window.localStorage.getItem("noToDo")
                if (!noToDo && meetings_planned.length > 0) {
                  this.rootPage = MeetingsToDoListPage
                } else {
                  this.rootPage = MainPage;
                }
              },
              _e => { },
              () => { }
            )
            this.rootPage = MainPage
          } else {
            this.rootPage = LoginPage;
            this.toastCtrl.create({
              message: 'Non hai i permessi per accedere al portale',
              duration: 2000,
              position: 'top'
            }).present()
          }
        } else {
          this.rootPage = LoginPage;
        }
      }, e => {
        this.rootPage = LoginPage;
        console.log("AppComponent -> Error - Need login");
        console.log(e)
      }, () => {

      })
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts